import { Component, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MyConfigOrganization } from '../../../../models/myConfig';
import { BackOffice24StatesService } from '../state/back-office24-states.service';
import { Subscription } from 'rxjs';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { ParkingSession } from '../../../../models/orderModel';

@Component({
  selector: 'app-parking-fines',
  standalone: false,
  templateUrl: './parking-fines.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parking-fines.component.css'
})
export class ParkingFinesComponent {
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();
  parkingSessions: ParkingSession[];
  filteredSessions: ParkingSession[];
  parkings: any[];
  searchTerm: string = '';
  isLoading: boolean = false;
  activeRequests: number = 0;

  constructor(
    private backOffice24StatesService: BackOffice24StatesService,
    private backOfficeService: BackOfficeService,
  ) { }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.subscribe(
      org => {
        this.organization = org
        this.parkings = org?.config?.parkings;
      }
    );

    this.getParkingSession();
  }

  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  incrementRequests() {
    this.activeRequests++;
    if(this.activeRequests > 0) {
      this.isLoading = true;
    }
  }

  decrementRequests() {
    if(this.activeRequests > 0) {
      this.activeRequests--;
    }
    if(this.activeRequests === 0) {
      this.isLoading = false;
    }
  }

  getParkingSession() {
    this.incrementRequests();
    this.backOfficeService.getParkingSession(this.organization.organizationId).subscribe(
      (res: any) => {
        console.log(res);
        this.parkingSessions = res;
        this.filteredSessions = [...this.parkingSessions];
        this.parkingSessions.forEach((session: any) => {
          session.parkingName = this.parkings.find((parking: any) => parking.parkingId === session.parkingId)?.parkingName;
        });
        this.decrementRequests();
      },
      (err: any) => {
        console.error(err);
        this.decrementRequests();
      }
    );
  }

  // createParkingSession() {
  //   const parkingSession: ParkingSession = {

  //   };
  //   this.backOfficeService.createParkingSession(this.organization.organizationId, {}).subscribe(
  //     (res: any) => {
  //       console.log(res);
  //       this.getParkingSession();
  //     },
  //     (err: any) => {
  //       console.error(err);
  //     }
  //   );
  // }

  ngOnDestroy(): void {
    this.orgSubscription.unsubscribe();
  }

  applyFilter() {
    if (!this.searchTerm.trim()) {
      this.filteredSessions = [...this.parkingSessions];
      return;
    }

    const searchTermLower = this.searchTerm.toLowerCase().trim();
    this.filteredSessions = this.parkingSessions.filter(session =>
      session.licensePlate?.toLowerCase().includes(searchTermLower)
    );
  }
}
